<!-- 注册审批 -->
<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <el-form :inline="false"
             :model="dataForm" ref="dataForm">
      <el-row>
        <el-col :span="8">
          <el-form-item label="课程编号">
            <el-input disabled v-model="dataForm.courseCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="课程名称">
            <el-input disabled v-model="dataForm.courseNameCn"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="用户ID">
            <el-input disabled v-model="dataForm.userCode"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="申请人名称">
            <el-input disabled v-model="dataForm.userName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="经销商名称">
            <el-input disabled v-model="dataForm.orgName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="申请开课城市">
            <el-input disabled v-model="dataForm.cityName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="申请时间">
            <el-input disabled v-model="dataForm.applyDate"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="审核时间">
            <el-input disabled v-model="dataForm.approvalDate"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
export default {
  data () {
    return {
      dataForm : {
      },
      courseDemandApplyId: undefined
    }
  },
  computed: {
  },
  // userRole hradminAudit 第一步审批 areaAudit 第二步审批
  created () {
    // 接收广播
    this.$eventHub.$on(this.GLOBAL.ACTIVATED_UPCOMING, (data) => {
      this.initialization()
    })
  },
  mounted () {
    this.initialization()
  },
  methods: {
    // 页面初始化
    initialization () {
      this.courseDemandApplyId = undefined
      if (this.$route.query.courseDemandApplyId !== undefined) {
        this.courseDemandApplyId = this.$route.query.courseDemandApplyId
        this.getRegisterOffering()
      }
    },
    getRegisterOffering () {
      this.dataForm = {}
      this.$request.post(`/learning/offeringregiste/infoCourseDemandApply`,{courseDemandApplyId: this.courseDemandApplyId}).then((res, total, code, data) => {
        this.dataForm = data.data
        this.dataForm['courseCode']=data.data.courseInfoDTO.courseCode
        this.dataForm['courseNameCn']=data.data.courseInfoDTO.courseNameCn
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style type="text/css" scoped>
</style>
